import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { FitnessClassesDataService, FitnessClassesColumnsService } from '../../../services';
import { FitnessClass, FitnessClassesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-fitness-class-details',
  templateUrl: './fitness-class-details.component.html',
  styleUrls: ['./fitness-class-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class FitnessClassDetailsComponent implements OnInit, OnDestroy {

  public fitnessClass: FitnessClass = {};
  public fitnessClasses: FitnessClass[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private fitnessClassesDataService: FitnessClassesDataService,
    private fitnessClassesColumnsService: FitnessClassesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Fitness Class - Details');
        this.getFitnessClass(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.fitnessClass !== 'undefined') {
      this.fitnessClass = this.dynamicDialogConfig.data.fitnessClass;
    }
    this.columns = this.fitnessClassesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getFitnessClass(id: number): void {
    this.isLoading = true;
    this.fitnessClassesDataService.getFitnessClass(id).subscribe((response: FitnessClass|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.fitnessClass = response;
      }
    });
  }

  list() {
    this.router.navigate(['/fitness-classes']);
  }

  add() {
    this.router.navigate(['/fitness-classes/add']);
  }

  edit() {
    this.router.navigate(['/fitness-classes/edit/' + this.fitnessClass.id]);
  }

}
@Component({
  selector: 'app-fitness-class-details',
  templateUrl: './fitness-class-details.component.html',
  styleUrls: ['./fitness-class-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogFitnessClassDetailsComponent extends FitnessClassDetailsComponent {
}

